import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/salesContent';
export function Testimonials() {
  return <section className="bg-bone px-5 py-14 sm:px-8" data-id="element-108" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-6xl" data-id="element-109" data-mp="3fz5ojz7ahmhb">
        <h2 className="text-center font-display text-[24px] font-bold text-plum sm:text-[30px]" data-id="element-110" data-mp="3fy30dz1cpy53">
          Resultados Reales de Personas Reales
        </h2>

        <div className="mt-9 grid gap-5 md:grid-cols-3" data-id="element-111" data-mp="36zinjeih2ios">
          {testimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-2xl border border-plum/10 bg-white p-6 shadow-[0_10px_30px_-24px_rgba(45,27,78,0.55)]" data-id="element-112" data-mp="31zd3okig20h9">
              <div className="flex items-center gap-3" data-id="element-113" data-mp="2s28bo41x3asj">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-deep font-display text-[18px] font-bold text-gold" data-id="element-114" data-mp="2s3tai5v9lfw7">
                  {t.name.charAt(0)}
                </span>
                <div data-id="element-115" data-mp="h5y8adksjb33">
                  <p className="text-[14px] font-bold text-ink" data-id="element-116" data-mp="h5ornglmyga2">{t.name}</p>
                  <p className="text-[12px] text-neutral-500" data-id="element-117" data-mp="m51alq9dz37d">{t.age}</p>
                </div>
              </div>

              <div className="mt-4 flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-118" data-mp="78ab7gzpprhr">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-119" data-mp="c7dfv0bs5vp7" data-mpi={i} />)}
              </div>

              <blockquote className="mt-3 text-[14px] leading-relaxed text-neutral-700" data-id="element-120" data-mp="14vj2xtqb3ws7">
                “{t.quote}”
              </blockquote>

              <figcaption className="mt-auto pt-5" data-id="element-121" data-mp="q5l6yrm4y2sg">
                <span className="inline-block rounded-full bg-emerald-deep/10 px-3 py-1.5 text-[12px] font-bold text-emerald-deep" data-id="element-122" data-mp="v5ptay9q5rql">
                  {t.badge}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}